export const login = {
    username: 'Username',
    usernameRequired: 'Username is required',
    usernameInvalid: 'Please enter a valid username',

    password: 'Password',
    passwordRequired: 'Password is required',
    showPassword: 'Show password!',
    hidePassword: 'Hide password!',

    login: 'LOGIN',
    or: 'OR',
    haveAccount: "Don't have an account?",
    create: 'Create an account',
    logout: 'Logout'
}

export const register = {
    welcome: 'Welcome to speKwo',
    heading: 'CREATE AN ACCOUNT',
    updateHead: 'UPDATE AN ACCOUNT',

    firstname: 'First name',
    firstnameRequired: 'First name is required',

    lastname: 'Last name',
    lastnameRequired: 'Last name is required',

    email: 'Email',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email address',
    emailExist: 'Email is already exist',

    password: 'Password',
    passwordRequired: 'Password is required',

    passwordConfirm: 'Password (Confirm)',
    passwordConRequired: 'Password confirmation is required',
    passwordMismatch: 'Passwords must match',

    phoneNumber: 'Phone number (999-999-9999)',
    phoneNumberRequired: 'Phone number is required',

    address: 'Address',
    addressRequired: 'Address is required',

    role: 'Select a role',
    accept: 'Accept',
    terms: 'terms and conditions',
    alreadyhave: 'Already have an account?',
    login: 'Login'
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/utils/auth.ts